import(/* webpackMode: "eager" */ "/workspace/node_modules/next/font/google/target.css?{\"path\":\"src/app/fonts.tsx\",\"import\":\"Roboto_Slab\",\"arguments\":[{\"weight\":\"400\",\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-RobotoSlab\"}],\"variableName\":\"robotoSlab\"}");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/font/google/target.css?{\"path\":\"src/app/fonts.tsx\",\"import\":\"Roboto_Condensed\",\"arguments\":[{\"weight\":\"400\",\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-RobotoCondensed\"}],\"variableName\":\"robotoCondensed\"}");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/workspace/packages/shared/src/components/auth/AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/shared/src/components/auth/LoginForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/shared/src/components/auth/SuperuserGuard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/workspace/packages/shared/src/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useIsMobile"] */ "/workspace/packages/shared/src/hooks/use-mobile.ts");
;
import(/* webpackMode: "eager", webpackExports: ["AuthContext","useAuth"] */ "/workspace/packages/shared/src/lib/auth/context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useFetchCollection"] */ "/workspace/packages/shared/src/lib/hooks/useFetchCollection.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useFetchDoc"] */ "/workspace/packages/shared/src/lib/hooks/useFetchDoc.ts");
;
import(/* webpackMode: "eager" */ "/workspace/packages/web/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/workspace/packages/web/src/components/auth/AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OrgGuard"] */ "/workspace/packages/web/src/components/layout/OrgGuard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TopNav"] */ "/workspace/packages/web/src/components/layout/TopNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeatureFlagsProvider"] */ "/workspace/packages/web/src/lib/context/FeatureFlagsContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OrgProvider"] */ "/workspace/packages/web/src/lib/context/OrgContext.tsx");
